import React, { Component } from 'react';
import { Router, Switch, Route } from 'react-router-dom';

import { history } from '../helpers/History';
import Login from '../scenes/login';
import Home from '../scenes/home';
import NavigationBar from '../components/NavigationBar';
import Agricultores from '../scenes/agricultor';
import Motoristas from '../scenes/motorista';
import MotoristaContainer from '../scenes/motorista/container';
import Pesagens from '../scenes/pesagem';
import PesagemContainer from '../scenes/pesagem/container';
import PrinterContainer from '../scenes/pesagem/printer';
import CodeContainer from '../scenes/code/container';

import * as Constants from '../utils/constants'
import AgricultorContainer from '../scenes/agricultor/container';
import { PrivateRoute } from '../components/PrivateRoute'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as loginAction from '../services/login/Action';

class Routes extends Component {

  constructor() {
    super();

    this.state = {
      autenticado: window.sessionStorage.getItem('token')
    };

    this.autenticar = this.autenticar.bind(this);
    this.logout = this.logout.bind(this);

  }

  autenticar() {
    this.setState(prevState => ({
      autenticado: !prevState.autenticado
    }));
  }

  logout = event => {
    return this.props.action.efetuarLogoutAction().then(() => {
      this.setState(prevState => ({
        autenticado: !prevState.autenticado
      }));
      history.push("/")
    });
  }

  LoginProp = (props) => {
    return (
      <Login 
        autenticar={this.autenticar}
        {...props}
      />
    );
  }

  render() {
    return (
      <div className="App">
        <Router history={history}>
          <div>
            <NavigationBar autenticado={this.state.autenticado} logout={this.logout} {...this.props} />

            <Switch>
              <Route exact path='/' component={this.LoginProp} />
              <PrivateRoute exact path={Constants.ROUTE_URL_HOME} component={Home} />
              <PrivateRoute exact path={Constants.ROUTE_URL_AGRICULTORES} component={Agricultores} />
              <PrivateRoute exact path={Constants.ROUTE_URL_AGRICULTOR} component={AgricultorContainer} />
              <PrivateRoute exact path={Constants.ROUTE_URL_EDIT_AGRICULTOR} component={AgricultorContainer} />
              <PrivateRoute exact path={Constants.ROUTE_URL_TRANSPORTADORAS} component={Motoristas} />
              <PrivateRoute exact path={Constants.ROUTE_URL_TRANSPORTADORA} component={MotoristaContainer} />
              <PrivateRoute exact path={Constants.ROUTE_URL_EDIT_TRANSPORTADORA} component={MotoristaContainer} />
              <PrivateRoute exact path={Constants.ROUTE_URL_PESAGENS} component={Pesagens} />
              <PrivateRoute exact path={Constants.ROUTE_URL_PESAGEM} component={PesagemContainer} />
              <PrivateRoute exact path={Constants.ROUTE_URL_EDIT_PESAGEM} component={PesagemContainer} />
              <Route exact path={Constants.ROUTE_URL_READER_CODE} component={CodeContainer} />
              <PrivateRoute exact path={Constants.ROUTE_URL_ABSTRACT_PESAGEM} component={PrinterContainer} />
            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loginObject: state.loginReducer.loginObject
});


const mapDispatchToProps = dispatch => ({
  action: bindActionCreators({ ...loginAction }, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(Routes);